import { useState } from 'react';

import AccessTimeRoundedIcon from '@mui/icons-material/AccessTimeRounded';
import PercentRoundedIcon from '@mui/icons-material/PercentRounded';

import InfoTooltipIcon from '@/components/icons/InfoTooltipIcon';
import {
  Alert,
  AlertTitle,
  Box,
  Divider,
  Grid,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
  Typography,
} from '@mui/material';
import EnergyAnalyzerFilterInput from '../../../components/forms/energyxplorer/EnergyAnalyzerFilterInput';
import DurationAnalysisChart from '../../../components/highcharts/powerAnalyser/DurationAnalysisChart';

const DurationAnalysisDialog = ({
  data = [],
  isLoading = true,
  setFilterOptions,
  ...props
}) => {
  const handleApplyFilters = async (filters) => {
    setFilterOptions(filters);
  };
  const [xAxisMode, setXAxisMode] = useState('percentage');

  return (
    <>
      <Box display={'flex'} flexDirection={'column'}>
        <Box display={'flex'} sx={{ mt: 2 }}>
          <Grid container columns={12}>
            <Grid item md={8}>
              {data ? (
                <DurationAnalysisChart
                  data={data.DurationAnalysisData}
                  loadProfiles={data.LoadProfiles}
                  xAxisMode={xAxisMode}
                  isLoading={isLoading}
                />
              ) : (
                <Alert severity="error" sx={{ mt: 2 }}>
                  <AlertTitle>Ingen data tilgængelig</AlertTitle>
                  Det er ikke muligt at vise døgnforbrugsanalyse.
                </Alert>
              )}
            </Grid>
            <Grid item md={4}>
              <Divider orientation="vertical" sx={{ height: 'auto' }} />
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography
                  variant="body1"
                  color="textSecondary"
                  fontWeight="bold"
                >
                  Filtrering
                </Typography>
                <InfoTooltipIcon title="Anvend filtrering på data for et bedre indblik." />
              </Box>
              <EnergyAnalyzerFilterInput
                handleApply={handleApplyFilters}
                setComparisonFilters={setFilterOptions}
                startHour={props?.row?.daytime_start}
                endHour={props?.row?.daytime_end}
              />
              <Box sx={{ display: 'flex', alignItems: 'center', marginTop: 2 }}>
                <Typography
                  variant="body1"
                  color="textSecondary"
                  fontWeight="bold"
                >
                  Visning
                </Typography>
              </Box>
              <ToggleButtonGroup
                value={xAxisMode}
                exclusive
                onChange={(e, newValue) => {
                  if (newValue) setXAxisMode(newValue);
                }}
                sx={{ my: 2 }}
              >
                <Tooltip title="Viser x-aksen i timer" placement="top">
                  <ToggleButton sx={{ borderRadius: 2 }} value="duration">
                    <AccessTimeRoundedIcon />
                  </ToggleButton>
                </Tooltip>
                <Tooltip title="Viser x-aksen i procent" placement="top">
                  <ToggleButton sx={{ borderRadius: 2 }} value="percentage">
                    <PercentRoundedIcon />
                  </ToggleButton>
                </Tooltip>
              </ToggleButtonGroup>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  );
};

export default DurationAnalysisDialog;
